//ListLine
//***********************************************************************************************************************
import * as React from "react";

export interface IListLineProp {
    id: string;
    first?: boolean;
    selected?: boolean;
    classes?: string;
    onClick?: (id: string) => void;
    onLongPress?: (id: string) => void;
    onRefreshList?: () => void;
}

export class ListLine extends React.Component<IListLineProp, {}> {
    private pressTimer: number = 0;
    private startY: number = 0;

    clearPressTimer = () => {
        clearTimeout(this.pressTimer);
        this.pressTimer = 0;
    };

    handleLinePress = (ev) => {
        const obj = this;
        //Get coordinates
        let y: number;
        if (ev.targetTouches) {
            // Prefer Touch Events
            y = ev.targetTouches[0].clientY;
        } else {
            // Either Mouse event or Pointer Event
            y = ev.clientY;
        }
        this.startY = y;
        //Set timer
        this.pressTimer = window.setTimeout(() => {
            //long press
            obj.clearPressTimer();
            if (obj.props.onLongPress) {
                obj.props.onLongPress(obj.props.id);
            }
        }, appConfig.longPressMs);
    };

    handleLineRelease = (ev) => {
        const props = this.props;
        //short press
        if (this.pressTimer > 0) {
            this.clearPressTimer();
            //Calculate finger movement
            let lastY = 0;
            if (ev.changedTouches && ev.changedTouches.length > 0) {
                lastY = ev.changedTouches[ev.changedTouches.length - 1].clientY;
            } else if (ev.clientX) {
                lastY = ev.clientY;
            }
            const yDiff = this.startY - lastY;
            if (Math.abs(yDiff) < 10) {
                if (props.onClick) {
                    props.onClick(props.id);
                }
            } else if (props.onRefreshList && props.first && Math.abs(yDiff) > 30 && yDiff < 0) { //First item and finger moved down more than x pixels
                props.onRefreshList();
            }
        }
    };

    render() {
        const props = this.props;
        /* eslint-disable react/prop-types */
        if (!props.onLongPress) {
            return (
                <div className={(props.selected ? "selected" : "") + (props.classes ? " " + props.classes : "")} onClick={props.onClick ? () => props.onClick(props.id) : null}>
                    {props.children}
                </div>
            );
        } else {
            return (
                <div className={((props.selected ? "selected" : "") + (props.classes ? " " + props.classes : "")).trim()}
                    onTouchStart={this.handleLinePress}
                    onTouchEnd={this.handleLineRelease}
                    onMouseDown={this.handleLinePress}
                    onMouseUp={this.handleLineRelease}
                    onMouseLeave={this.handleLineRelease}>
                    {props.children}
                </div>
            );
        }
        /* eslint-disable react/prop-types */
    }
}